







import StaticPagesWrapper from '~/modules/storyblok/components/Static/StaticPagesWrapper.vue';

export default {
  name: 'AddressPage',
  components: {
    StaticPagesWrapper,
  },
  layout: 'basic',
  middleware: [
    'story-url-resolver',
  ],
  async asyncData(context) {
    if (context.app.currentStory) {
      const { currentStory } = context.app;
      return { currentStory };
    }
    return { currentStory: null };
  },
  head: {},
};
